import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
	selector: '[appValidateNumber][formControlName],[appValidateNumber][formControl],[appValidateNumber][ngModel]',
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => NumberValidator),
			multi: true
		}
	]
})
export class NumberValidator implements Validator {
	@Input() public allowNegatives = true;
	@Input() public allowZero = true;

	validate(c: AbstractControl) {
		if (c.value == null || c.value.length === 0) {
			return null;
		} else {
			let NUMBER_REGEX = /^([-])?[0-9]+([.][0-9]+)?$/g;

			if (!this.allowNegatives) {
				NUMBER_REGEX = /^[0-9]+([.][0-9]+)?$/g;
			}

			if (!this.allowZero && parseInt(c.value, 10) === 0) {
				return {
					invalidNumber: true
				};
			}

			return NUMBER_REGEX.test(c.value) ? null : {
				invalidNumber: true
			};
		}
	}
}
